export const API_BASE =
  process.env.REACT_APP_API_BASE_URL || 'https://api.mitadtu.in';

export const authHeaders = (extra = {}) => {
  const token = localStorage.getItem('adminToken');
  return {
    Authorization: token ? `Bearer ${token}` : undefined,
    ...extra,
  };
};

export const jsonHeaders = (extra = {}) => ({
  'Content-Type': 'application/json',
  ...authHeaders(extra),
});




















